import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useCompanyTypeReducer = () => useSelector((state: ApplicationState) => state.companyType);
